import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
import { AxiosError } from 'axios';

export const useGetAxiosError = () => {
  const { t } = useTranslation(['common']);
  return useCallback(
    (e: unknown): string => {
      if (e instanceof AxiosError && e.response) {
        if (e.response?.status === 400) {
          const errors = e.response.data?.errors ?? e.response.data;
          const messages =
            typeof errors === 'string'
              ? [errors]
              : errors && typeof errors === 'object'
              ? Object.values(errors).flat()
              : [];
          const message = messages.find(
            (value): value is string =>
              typeof value === 'string' && value.trim().length > 0,
          );
          if (message) return message;
        }
        if (e.response?.status >= 500) {
          return t('common:serverError', { status: e.response.status });
        }
      }
      return t('common:unknownError', {
        message: e instanceof Error ? e.message : '',
      });
    },
    [t],
  );
};
